import { render } from "./PrivacyPolicy_ios.vue?vue&type=template&id=682c242b&scoped=true"
import script from "./PrivacyPolicy_ios.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy_ios.vue?vue&type=script&lang=js"

import "./PrivacyPolicy_ios.vue?vue&type=style&index=0&id=682c242b&scoped=true&lang=less"

import exportComponent from "/opt/apps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-682c242b"]])

export default __exports__